import OnlinePayments from './OnlinePayments'

export * from './components'
export * from './OnlinePayments'
export * from './TOnlinePaymentsStore'
export default OnlinePayments
